(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDetailController', QueueTypeDetailController);

    QueueTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QueueType'];

    function QueueTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueTypeUpdate', function(event, result) {
            vm.queueType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
